// gloss
export const firstQueryParam = (value: string | string[] | undefined): string | null => {
  if (value === undefined) return null;
  return Array.isArray(value) ? (value[0] ?? null) : value;
};
